import { Translate } from '../core';
import Common from './common';
import Seguridad from './seguridad'

class ServiceBase {
  urlAPI: string;
  localTimezone: string;

  constructor(api: string) {
    this.urlAPI = api.endsWith('/') ? api : `${api}/`;
    this.localTimezone = (new Date().getTimezoneOffset() >= 0 ? '+' : '-') + `${Math.abs(100 * new Date().getTimezoneOffset() / 60)}`.padStart(4, '0')
  }
  
  GetHeaders = (token?: string) : HeadersInit => {
    let headers : HeadersInit = { 
      "accept": "application/json",
      "Content-Type": "application/json",
      "Accept-Languaje": "*",
      "Cnet-Lang": `${Translate.currentlocale === 'es' ? 1 : 2 }`,
      "Cnet-tz": this.localTimezone
    };

    if (window.app_usems) return { ...headers, ...{ "Authorization": `Bearer ${Common.session.get("AUTHTOKEN")}` } };

    if (token)
      return { ...headers, ...{ "Authorization": `Basic ${token}` } }

    /*
    if (Seguridad?.User) {
      const hoy = new Date(new Date().setHours(new Date().getHours() + 2));
      const vencDay = hoy.getFullYear() * 10000 + (hoy.getMonth() + 1) * 100 + (hoy.getDate());
      const vencHour = hoy.getHours() * 10000 + hoy.getMinutes() * 100 + hoy.getSeconds();
      const token = btoa(`${Seguridad.User.id}|${Seguridad.User.login}|${vencDay}${vencHour}|${Seguridad.User.password}`);
      return { ...headers, ...{ "Authorization": `Basic ${token}` } }
    }*/

    return headers;
  }

  /**
   * Realiza una petición GET con la cabecera standard
   * @param {string} method Nombre del método a llamar
   */
  GetFetch = async <T>(method : string, parms : any, headers? : any) : Promise<T> => {
    let url = `${this.urlAPI}${method.startsWith('/') ? method.substr(0, method.length - 2) : method}`;
    if (parms) {
      const keys = Object.keys(parms);
      const urlParms = keys.filter(k => parms[k] !== undefined && parms[k] !== null).map(k => `${k}=${encodeURIComponent(parms[k])}`).join('&');
      url = `${url}?${urlParms}`;
    }
    let H = this.GetHeaders();    
    if (headers) H = { ...H, ...headers };

    console.log("Get", url, H);
    return fetch(url, { method: 'GET', headers: H })
      .then((payload : any) => {
        if (payload && payload.status === 401) {
          Seguridad.Logout();
          window.location.reload();
          return Promise.reject("Credenciales inválidas");
        }
        if (payload && payload.title)
          return Promise.reject(payload.title);
        if (!payload)
          return Promise.reject("Error desconocido al acceder al servicio. Verifique la conectividad.");
        
        return payload.json ? payload.json() : payload;
      })
  }

  /**
   * Realiza una petición POST con la cabecera standard
   * @param {string} method Nombre del método a llamar
   */
  PostFetch = async <T>(method : string, body : any) : Promise<T> => {
    let url = `${this.urlAPI}${method.startsWith('/') ? method.substr(0, method.length - 2) : method}`;
    console.log("Post", url, body);

    return fetch(url, { method: 'POST', body: JSON.stringify(body), headers: this.GetHeaders() })
      .then((payload:any) => {
        if (payload && payload.status === 401) {
          return Promise.reject("Credenciales inválidas");
        }
        if (payload && payload.title)
          return Promise.reject(payload.title);
        if (!payload)
          return Promise.reject("Error desconocido al acceder al servicio. Verifique la conectividad.");

        return payload.json ? payload.json() : payload;
      })
  }

  /**
   * Realiza una petición PUT con la cabecera standard
   * @param {string} method Nombre del método a llamar
   */
  PutFetch = async <T>(method : string, body : any) : Promise<T> => {
    let url = `${this.urlAPI}${method.startsWith('/') ? method.substr(0, method.length - 2) : method}`;
    console.log("Put", url, body);

    return fetch(url, { method: 'PUT', body: JSON.stringify(body), headers: this.GetHeaders() })
      .then((payload:any) => {
        if (payload && payload.status === 401) {
          return Promise.reject("Credenciales inválidas");
        }
        if (payload && payload.title)
          return Promise.reject(payload.title);
        if (!payload)
          return Promise.reject("Error desconocido al acceder al servicio. Verifique la conectividad.");

        return payload.json ? payload.json() : payload;
      })
  }

  /**
   * Realiza una petición GET con la cabecera standard
   * @param {string} method Nombre del método a llamar
   */
  DeleteFetch = async <T>(method : string, parms : any, headers? : any) : Promise<T> => {
    let url = `${this.urlAPI}${method.startsWith('/') ? method.substr(0, method.length - 2) : method}`;
    if (parms) {
      const keys = Object.keys(parms);
      const urlParms = keys.filter(k => parms[k] !== undefined).map(k => `${k}=${parms[k]}`).join('&');
      url = `${url}?${urlParms}`;
    }
    let H = this.GetHeaders();    
    if (headers) H = { ...H, ...headers };
    console.log("Delete", url, H);
    return fetch(url, { method: 'DELETE', headers: H })
      .then((payload : any) => {
        if (payload && payload.status === 401) {
          Seguridad.Logout();
          window.location.reload();
          return Promise.reject("Credenciales inválidas");
        }
        if (payload && payload.title)
          return Promise.reject(payload.title);
        if (!payload)
          return Promise.reject("Error desconocido al acceder al servicio. Verifique la conectividad.");

        return payload.json ? payload.json() : payload;
      })
  }

}

export default ServiceBase;